import { c as _c } from "react/compiler-runtime";
import { fetchManagerList, postCancelManager, postWriteManager } from '@module/apis/client-side/manager';
import type { FetchManagerListParams, ManagerListResponse, PostCancelManagerParams, PostCancelManagerResponse, PostWriteManagerParams, PostWriteManagerResponse } from '@module/apis/client-side/manager/type';
import { type UseInfiniteQueryOptions, type UseMutationOptions, useInfiniteQuery, useMutation, useQuery } from '@tanstack/react-query';
import type { CustomUseQueryOptions } from '../type';
import { managerQueryKeys } from './managerQueryKeys';
export const useManagerListQuery = (managerListParams, options) => {
  const $ = _c(8);
  let t0;
  if ($[0] !== managerListParams) {
    t0 = managerQueryKeys.fetchManagerList(managerListParams);
    $[0] = managerListParams;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== managerListParams) {
    t1 = () => fetchManagerList(managerListParams);
    $[2] = managerListParams;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== options || $[5] !== t0.queryKey || $[6] !== t1) {
    t2 = {
      queryKey: t0.queryKey,
      queryFn: t1,
      ...options
    };
    $[4] = options;
    $[5] = t0.queryKey;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return useQuery(t2);
};
export const useManagerListInfiniteQuery = (params, options) => {
  const $ = _c(8);
  let t0;
  if ($[0] !== params) {
    t0 = managerQueryKeys.fetchManagerList(params);
    $[0] = params;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== params) {
    t1 = t2 => {
      const {
        pageParam: t3
      } = t2;
      const pageParam = t3 === undefined ? 1 : t3;
      const actualPageParam = typeof pageParam === "number" ? pageParam : 1;
      const offset = params.limit * ((actualPageParam || 1) - 1);
      return fetchManagerList({
        ...params,
        offset
      });
    };
    $[2] = params;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== options || $[5] !== t0.queryKey || $[6] !== t1) {
    t2 = {
      initialPageParam: 1,
      queryKey: t0.queryKey,
      queryFn: t1,
      ...options,
      getNextPageParam: _temp2,
      select: _temp4
    };
    $[4] = options;
    $[5] = t0.queryKey;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return useInfiniteQuery(t2);
};
export const usePostWriteManagerMutation = options => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = managerQueryKeys.postWriteManager();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== options) {
    t1 = {
      mutationKey: t0.queryKey,
      mutationFn: _temp5,
      ...options
    };
    $[1] = options;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return useMutation(t1);
};
export const usePostCancelManagerMutation = options => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = managerQueryKeys.postCancelManager();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== options) {
    t1 = {
      mutationKey: t0.queryKey,
      mutationFn: _temp6,
      ...options
    };
    $[1] = options;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return useMutation(t1);
};
function _temp(page) {
  return page.list;
}
function _temp2(lastPage, allPages) {
  const totalFetchedItems = allPages.flatMap(_temp).length;
  if (totalFetchedItems < lastPage.page.total) {
    const nextPage = allPages.length + 1;
    return nextPage;
  }
}
function _temp3(page_0) {
  return page_0.list ?? [];
}
function _temp4(data) {
  return {
    pages: data?.pages.flatMap(_temp3),
    pageParams: data.pageParams,
    total: data?.pages.length > 0 ? data?.pages[0].page.total : 0
  };
}
function _temp5(postWriteManagerParams) {
  return postWriteManager(postWriteManagerParams);
}
function _temp6(postCancelManagerParams) {
  return postCancelManager(postCancelManagerParams);
}